

function StatusFilter({ filterValue, setFilterValue }) {

    return <div className="entries-wrapper">
        <select
            className="form-select select-drop-icon"
            aria-label="Default select example"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
        >
            <option value="" selected>All</option>
            <option value="Pending">Pending</option>
            <option value="Allocated">Allocated</option>
            <option value="Deallocated">Deallocated</option>
            <option value="Reallocated">Reallocated</option>
            <option value="Inprogress">Inprogress</option>
            <option value="Completed">Completed</option>
            <option value="Approved">Approved</option>
            <option value="Rejected" >Rejected</option>
            <option value="Hold" >Hold</option>
        </select>
    </div>

}

export default StatusFilter